import { createStore, createEvent } from "effector"
import { useUnit } from "effector-react"

import StorageService from "services/StorageService"
import { NavbarState, StorageKey } from "config/constants"

const expandNavbar = createEvent()
const collapseNavbar = createEvent()
const setForceHideSubmenus = createEvent<boolean>()

const navbarState = createStore<NavbarState>((StorageService.getItem(StorageKey.navbarState) as NavbarState) || NavbarState.collapsed)
const forceHideSubmenus = createStore<boolean>(false)

navbarState
    .on(expandNavbar, () => {
        StorageService.setItem(StorageKey.navbarState, NavbarState.expanded)
        return NavbarState.expanded
    })
    .on(collapseNavbar, () => {
        StorageService.setItem(StorageKey.navbarState, NavbarState.collapsed)
        return NavbarState.collapsed
    })

forceHideSubmenus.on(setForceHideSubmenus, (_, payload: boolean) => payload)

export function useNavbarStore() {
    return {
        navbarState: useUnit(navbarState),
        forceHideSubmenus: useUnit(forceHideSubmenus),
        expandNavbar,
        collapseNavbar,
        setForceHideSubmenus,
    }
}
